// Budowniczowie JSON-LD. Kształt walidowany przy buildzie przez
// scripts/validate-jsonld.js (wymagane pola, typy, absolutne URL-e).
import { PUBLISHER } from "./data";

const organization = () => ({
  "@type": "Organization",
  name: PUBLISHER.name,
  url: PUBLISHER.url,
  logo: {
    "@type": "ImageObject",
    url: PUBLISHER.logo,
    width: PUBLISHER.logoWidth,
    height: PUBLISHER.logoHeight,
  },
});

const person = (author) => ({
  "@type": "Person",
  name: author.name,
  url: author.url,
  ...(author.jobTitle ? { jobTitle: author.jobTitle } : {}),
  ...(author.sameAs && author.sameAs.length ? { sameAs: author.sameAs } : {}),
});

export function blogPostingLd(post, author) {
  return {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: post.title,
    description: post.description,
    datePublished: post.datePublished,
    dateModified: post.dateModified,
    inLanguage: post.lang,
    url: post.url,
    mainEntityOfPage: { "@type": "WebPage", "@id": post.url },
    image: [post.ogImage],
    author: person(author),
    publisher: organization(),
    ...(post.tags.length ? { keywords: post.tags.join(", ") } : {}),
  };
}

// Budowane z sekcji FAQ artykułu (frontmatter `faq`), nie z osobnego pola —
// treść w JSON-LD musi być dokładnie tą, którą widzi czytelnik.
export function faqPageLd(faq) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faq.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };
}

export function breadcrumbLd(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function blogLd({ url, name, description, lang, posts }) {
  return {
    "@context": "https://schema.org",
    "@type": "Blog",
    "@id": url,
    url,
    name,
    description,
    inLanguage: lang,
    publisher: organization(),
    blogPost: posts.map((p) => ({
      "@type": "BlogPosting",
      headline: p.title,
      description: p.description,
      url: p.url,
      datePublished: p.datePublished,
      dateModified: p.dateModified,
    })),
  };
}

export function collectionPageLd({ url, name, description, lang, posts }) {
  return {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "@id": url,
    url,
    name,
    description,
    inLanguage: lang,
    isPartOf: { "@type": "Blog", "@id": `${url.split("/blog/")[0]}/blog/` },
    mainEntity: {
      "@type": "ItemList",
      itemListElement: posts.map((p, i) => ({
        "@type": "ListItem",
        position: i + 1,
        url: p.url,
        name: p.title,
      })),
    },
  };
}

export function profilePageLd(author, posts) {
  return {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    "@id": author.url,
    url: author.url,
    inLanguage: author.lang,
    mainEntity: {
      ...person(author),
      description: author.bioText,
      ...(author.credentials && author.credentials.length
        ? { knowsAbout: author.credentials }
        : {}),
    },
    ...(posts.length
      ? {
          mainEntityOfPage: {
            "@type": "ItemList",
            itemListElement: posts.map((p, i) => ({
              "@type": "ListItem",
              position: i + 1,
              url: p.url,
              name: p.title,
            })),
          },
        }
      : {}),
  };
}
